var _rect, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCvLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 109,
    height: 109,
    viewBox: "0 0 109 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 35.9688,
    y: 35.9707,
    width: 73.0297,
    height: 73.0297,
    fill: "#A3CD9E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.5148,
    cy: 36.5148,
    r: 36.5148,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvLogo2);
export default __webpack_public_path__ + "static/media/CVLogo2.0e8a0d7f10a4962413a5970b58c4617e.svg";
export { ForwardRef as ReactComponent };